export const EPISODES_PAGE_SIZE = 5
export const PODCAST_FEATURED_COUNT = 2
export const PODCAST_MORE_COUNT = 5
